import RefreshButton from "@buttons/RefreshButton";
import { UIDateFormat, UITimeFormat } from "@helpers/dates";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { DateInput, TimeInput } from "semantic-ui-calendar-react";
import { Checkbox, Form, Input } from "semantic-ui-react";

class CompanyFilters extends React.Component {
  useCurrentDateTime = () => {
    this.props.setUseCurrentDateTime();
  };

  handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.props.onChange(name, value);
  };

  handleSessionIDChange = (event) => {
    const value =
      event.target.value > 999999999 ? 999999999 : event.target.value;
    this.props.onChange("sessionId", value);
  };

  handleShowEvents = () => {
    this.props.onChange("includeEvents", !this.props.includeEvents);
  };

  updateDate(name, date, time) {
    this.props.onChange(
      name,
      moment(`${date} ${time}`, "DD-MM-YYYY HH:mm").toISOString(true),
    );
  }

  handleDateChange = (event, { name, value }) => {
    this.setState({ [name]: value }, () => {
      let time =
        name === "startDate"
          ? moment(this.props.startDate).format(UITimeFormat)
          : moment(this.props.endDate).format(UITimeFormat);
      this.updateDate(name, value, time);
    });
  };

  handleTimeChange = (event, { name, value }) => {
    this.setState({ [name]: value }, () => {
      let key = name === "startTime" ? "startDate" : "endDate";
      this.updateDate(key, this.state[key], value);
    });
  };

  convertParentDate(key) {
    return moment(this.props[key]).format(UIDateFormat);
  }

  convertParentTime(key) {
    return moment(this.props[key]).format(UITimeFormat);
  }

  render() {
    return (
      <Form id="companyFilters">
        <Form.Group>
          <Form.Field inline>
            <label style={{ width: "30px" }}>From:</label>
            <DateInput
              className="ui input"
              name="startDate"
              placeholder="Date"
              value={this.convertParentDate("startDate")}
              iconPosition="left"
              onChange={this.handleDateChange}
              animation="fade"
              popupPosition="bottom center"
              closable
              autoComplete="off"
            />
            <TimeInput
              className="ui input ml-0_5"
              name="startTime"
              placeholder="Time"
              value={this.convertParentTime("startDate")}
              iconPosition="left"
              onChange={this.handleTimeChange}
              animation="fade"
              popupPosition="bottom center"
              closable
              style={{ width: "90px" }}
              autoComplete="off"
            />
          </Form.Field>

          {this.props.hideTransactionFilter && (
            <Form.Field>
              <Checkbox
                name="zeroBetSessions"
                label="Zero Bet Sessions Only"
                checked={this.props.zeroBetSessions}
                onChange={() =>
                  this.props.onChange(
                    "zeroBetSessions",
                    !this.props.zeroBetSessions,
                  )
                }
              />
            </Form.Field>
          )}

          {this.props.hasShowEvents && (
            <Form.Field inline>
              <Checkbox
                label="Show Events"
                checked={this.props.includeEvents}
                onChange={this.handleShowEvents}
                name="includeEvents"
              />
            </Form.Field>
          )}

          {this.props.showUserField && (
            <Form.Field inline>
              <label>User:</label>
              <Input
                value={this.props.username}
                name="username"
                onChange={this.handleChange}
              />
            </Form.Field>
          )}

          <Form.Field inline>
            <label>Collection Week:</label>
            <Input
              type="number"
              value={this.props.week}
              min="0"
              name="week"
              onChange={this.handleChange}
            />
          </Form.Field>
        </Form.Group>
        <Form.Group>
          <Form.Field inline>
            <label style={{ width: "50px" }}>To:</label>

            <DateInput
              className="ui input"
              name="endDate"
              placeholder="Date"
              value={this.convertParentDate("endDate")}
              iconPosition="left"
              onChange={this.handleDateChange}
              animation="fade"
              popupPosition="bottom center"
              closable
              disabled={this.props.useCurrentDateTime}
              autoComplete="off"
            />
            <TimeInput
              className="ui input ml-0_5"
              name="time"
              placeholder="Time"
              value={this.convertParentTime("endDate")}
              iconPosition="left"
              onChange={this.handleTimeChange}
              animation="fade"
              popupPosition="bottom center"
              disabled={this.props.useCurrentDateTime}
              closable
              style={{ width: "90px" }}
              autoComplete="off"
            />
          </Form.Field>

          <Form.Field inline>
            <Checkbox
              checked={this.props.useCurrentDateTime}
              label="Current Time/Date"
              onChange={this.useCurrentDateTime}
            />
          </Form.Field>
        </Form.Group>
        <Form.Group>
          <RefreshButton
            style={{ marginLeft: "8px" }}
            refresh={this.props.refresh}
            disabled={!this.props.hasSelection}
            loading={this.props.loading}
          />
        </Form.Group>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    logIn: state.logIn,
  };
};

export default connect(mapStateToProps)(CompanyFilters);
